var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "answers_block" },
    [
      _c(
        "b-overlay",
        { attrs: { show: _vm.is_load } },
        [
          _c(
            "b-row",
            [
              _c("b-col", [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-md btn-block btn-outline-info waves-effect waves-themed",
                    on: { click: _vm.select_group },
                  },
                  [
                    _c("span", { staticClass: "fal fa-eject mr-1" }),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.__t("SELECT_GROUP")) +
                        "\n                "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("b-col", [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-md btn-block btn-outline-success waves-effect waves-themed",
                    on: { click: _vm.add_group },
                  },
                  [
                    _c("span", { staticClass: "fal fa-eject mr-1" }),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.__t("ADD_GROUP")) +
                        "\n                "
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          this.items.length > 0
            ? _c("div", { staticClass: "modofication_items mt-3" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-lg-6 col-sm-6 col-xl-6 border-right" },
                    [
                      _c("h3", [
                        _c("span", { staticClass: "badge badge-danger" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.__t("REQUIRED")) +
                              "\n                        "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm._l(this.req_group, function (group) {
                        return _c("product_group_new", {
                          key: group.id,
                          attrs: { item: group },
                          on: { remove_group: _vm.remove_group },
                        })
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-lg-6 col-sm-6 col-xl-6 border-right" },
                    [
                      _c("h3", [
                        _c("span", { staticClass: "badge badge-danger" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.__t("NOT_REQUIRED")) +
                              "\n                        "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm._l(this.not_req_group, function (group) {
                        return _c("product_group_new", {
                          key: group.id,
                          attrs: { item: group },
                          on: { remove_group: _vm.remove_group },
                        })
                      }),
                    ],
                    2
                  ),
                ]),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("group_choose"),
      _vm._v(" "),
      _c("group_modal", { on: { on_group_finish: _vm.new_group_created } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }